import ApplyRoutes from "@/routes/ApplyRoutes"
import AccountRoutes from "@/routes/AccountRoutes"
import DocumentRoutes from "@/routes/DocumentRoutes"
import HelpRoutes from "@/routes/HelpRoutes"
import ProviderRoutes from "@/routes/ProviderRoutes"
import StartRoutes from "@/routes/StartRoutes"
import FinishRoutes from "@/routes/FinishRoutes"
import ErrorRoutes from "@/routes/ErrorRoutes"
import InternalRoutes from "@/routes/InternalRoutes"
import TestRoutes from "@/routes/TestRoutes"
import { navigationService } from "@/service"
import { applicationState, sessionState } from "@/state"
import ProveRoutes from "@/routes/ProveRoutes"

export default [
    ...ProviderRoutes,
    ...ApplyRoutes,
    ...AccountRoutes,
    ...DocumentRoutes,
    ...ErrorRoutes,
    ...HelpRoutes,
    ...InternalRoutes,
    ...StartRoutes,
    ...TestRoutes,
    ...FinishRoutes,
    ...ProveRoutes,

    {
        path: "/",
        name: "index",
        redirect: () => {
            return navigationService.getHomeLocation()
        },
    },
    {
        path: "/home",
        name: "home",
        redirect: "/idle",
    },
    {
        path: "/home/:flowType",
        name: "flowTypeHome",
        redirect: () => {
            return navigationService.getRedirectLocation(
                navigationService.getProviderStartLocation(sessionState.providerKey, applicationState.applyMode)
            )
        },
    },
    {
        path: "/home/:flowType/:experienceType",
        name: "experienceTypeHome",
        redirect: (to, from) => {
            // TODO rbohn - not sure why I can't use to.params.flowType
            return { path: "/home/:flowType", params: { flowType: sessionState.flowType } }
        },
    },
    {
        path: "/idle",
        name: "idle",
        component: () => import("@/views/IdleView.vue"),
        meta: {
            public: true,
            stepper: false,
        },
    },

    {
        path: "/redirect/:redirect",
        name: "redirect",
        component: () => import("@/views/RedirectView.vue"),
    },

    {
        path: "/breakout/:lender/:lenderApplicationId",
        name: "iframeBreakout",
        component: () => import("@/views/IframeBreakoutView.vue"),
        meta: {
            public: true,
            stepper: false,
        },
    },

    {
        path: "*",
        redirect: "/",
    },
]
